import React from 'react';
import './button.css';
import Image from "../theme/Image";

export default function ({className = '', image, title}) {
    return (
        <div className={"buttonContainer " + className} style={{
            overflow: 'hidden',
            boxShadow: '0.07rem 0.21rem 0.29rem -0.07rem #919191'
        }}>
            <div className={"blueBackground leftBox"}>
                <Image image={image} style={{
                    width: "3.21rem",
                    verticalAlign: 'middle',
                    margin: 'auto'
                }} alt={"bank card"}/>
            </div>
            <div className={"flencheBackgroundLeft"}/>
            <span className={"uppercaseText"} style={{
                marginLeft: '1.43rem',
                display: 'flex',
                justifyContent: 'center'
            }}>
                <span style={{margin: 'auto'}}>{ title }</span>
            </span>
        </div>
    );
}
